export const DISMISS_ALERT = 'DISMISS_ALERT';
export const DISMISS_ALERT_SUCCESS = 'DISMISS_ALERT_SUCCESS';
export const DISMISS_ALERT_FAIL = 'DISMISS_ALERT_FAIL';
export const RESET_DISMISS_ALERT = 'RESET_DISMISS_ALERT';
